import { initializeApp } from "firebase/app";
import { getAuth, GithubAuthProvider, GoogleAuthProvider, RecaptchaVerifier } from "firebase/auth";
import { getFirestore, collection, addDoc } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDQaf9MpNV8eQ3Zf4OfpK_GeuijBRpc6ho",
  authDomain: "omore-games.firebaseapp.com",
  projectId: "omore-games",
  storageBucket: "omore-games.firebasestorage.app",
  messagingSenderId: "985074914859",
  appId: "1:985074914859:web:df0ac1e90a9bad98647c6e"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// export const auth = getAuth(app);
 const googleProvider = new GoogleAuthProvider();
 const githubProvider = new GithubAuthProvider();
const auth = getAuth(app);
const db = getFirestore(app);

const storage = getStorage(app);

export { auth, db, storage, collection, addDoc, ref, uploadBytes, getDownloadURL, firebaseConfig,googleProvider,githubProvider,RecaptchaVerifier };